import React from 'react';
import './header.scss';

const Header = () => {
  return (
    <header className="avia-header">
      <span className="avia-header__icon"></span>
    </header>
  );
};

export default Header;
